import styled from "styled-components";

export const Button = styled.button`
  width: 84px;
  height: 24px;
  background-color: #d7ffe0;
  color: #018c0f;
  text-align: center;
  font-family: Poppins;
  font-size: 9px;
  font-weight: 600;
  line-height: 26px;
  border-radius: 10px;
`;
